/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
var E = /* @__PURE__ */ ((r) => (r.TEXT = "text", r.IMAGE = "image", r.ICON = "icon", r))(E || {}), e = /* @__PURE__ */ ((r) => (r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r))(e || {}), R = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.primary = "primary", r.INFO = "info", r.SUCCESS = "success", r.WARNING = "warning", r.ERROR = "error", r))(R || {}), n = /* @__PURE__ */ ((r) => (r.START = "start", r.CENTER = "center", r.END = "end", r.STRETCHED = "stretched", r))(n || {});
export {
  E as avatarType,
  n as cardActionsLayout,
  e as cardOrientation,
  R as cardType
};
